// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"fYHjpH","link":"WNrzbL","disabled":"sK9KU3","navItem":"DsZX_v"};